import axios from 'axios';

export const apiHttpClientConfig = axios.create({
  baseURL: process.env.REACT_APP_BACK_URL,
  timeout: 20000,
});
